<template>
  <v-container fluid class="sor-detail" v-if="sor">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'sor-list'}">
        &lt;&lt; {{ $t('app_drawer.sor') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             small
             class="ml-4"
             @click="getSor">
        <v-icon small>fas fa-sync-alt</v-icon>
      </v-btn>
    </v-row>

    <v-row class="sor-info-wrapper">
      <v-col>
        <div class="sor-info">
          <h3>{{ sor.name }}</h3>
          <div>{{ $t('sor.edition') }}: {{ sor.edition.id }}</div>
          <div v-if="sor.previous_version">{{ $t('sor.previous_version') }}: {{ sor.previous_version.name }}</div>
          <div>{{ $t('sor.not_available_for_sale')}}</div>
        </div>
      </v-col>
    </v-row>

    <!--ACTION Input-->
    <v-row class="flex-grow-0"
           v-if="sor.finalised_at">
      <v-col>
        <v-btn color="primary"
               @click="$downloadFile(sor.finalised_pdf)">
          {{ $t('sor.download_pdf') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 sor-action-input-disable-row mb-2 rounded" v-if="!sor.finalised_at">
      <v-col>
        <span class="font-weight-bold mr-8">{{ $t('sor.action_input') }}</span>
        {{ $t('sor.action_input_not_available') }}
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 sor-action-input-row mb-2 rounded elevation-4" v-if="sor.finalised_at">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t('sor.action_input') }}</span>
        <span class="sor-finalised-div"
              v-if="sor.action_input_finalised_at">
          {{ $t('sor.finalised') }}
          <v-icon color="#5BC23F"
                  small>mdi-check</v-icon>
        </span>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!sor.action_input"
               @click="$downloadFile(sor.action_input.id)">
          {{ $t('sor.download_action_input') }}
        </v-btn>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!sor.finalised_action_input_dbf"
               @click="$downloadFile(sor.finalised_action_input_dbf)">
          {{ $t('sor.download_action_input_dbf') }}
        </v-btn>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!sor.reference_table"
               @click="$downloadFile(sor.reference_table)">
          {{ $t('sor.download_reference_table') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               small
               class="ml-4"
               v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && sor.action_input && !sor.action_input_finalised_at"
               @click="finaliseActionInput">
          {{ $t('sor.finalise') }}
        </v-btn>
<!--        <v-btn color="primary"-->
<!--               small-->
<!--               class="ml-4"-->
<!--               v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && sor.action_input && sor.action_input_finalised_at"-->
<!--               @click="unfinaliseActionInput">-->
<!--          {{ $t('sor.un_finalise') }}-->
<!--        </v-btn>-->
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table :items="actionItems"
                      :headers="actionHeaders"
                      hide-default-footer>
          <template #no-data>
            {{ $t('sor.action_input_being_generated')}}
          </template>
          <template #item.created_at="{value}">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{ sor.action_input_finalised_at ? $parseDate(sor.action_input_finalised_at) : '' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="flex-grow-0 sor-detail-section-title rounded-t pa-3">
      <span class="font-weight-bold">{{ $t('volume.title') }}</span>
      <v-btn color="primary"
             small
             class="ml-4"
             v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && !sor.finalised_at"
             @click="createVolume">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>

      <span class="sor-finalised-div"
            v-if="sor.finalised_at">
          {{ $t('sor.finalised') }}
          <v-icon color="#5BC23F"
                  small>mdi-check</v-icon>
        </span>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             small
             class="ml-4"
             v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && !sor.finalised_at"
             @click="finaliseSor">
        {{ $t('sor.finalise') }}
      </v-btn>
<!--      <v-btn color="primary"-->
<!--             small-->
<!--             class="ml-4"-->
<!--             v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) && sor.finalised_at"-->
<!--             :disabled="true || sor.action_input_finalised_at"-->
<!--             @click="unfinaliseSor">-->
<!--        {{ $t('sor.un_finalise') }}-->
<!--      </v-btn>-->
    </v-row>
    <v-row class="flex-grow-1 rounded-b">
      <VolumeList full-height
                  :edition-id="$route.params.editionId"
                  :sor-id="$route.params.sorId"
                  :refresh-trigger.sync="refreshTrigger"
                  :sor-finalised="!!sor.finalised_at"></VolumeList>
    </v-row>
    <!--    <v-row class="flex-grow-1">-->
    <!--      <SectionList full-height-->
    <!--                   :edition-id="$route.params.editionId"-->
    <!--                   :sor-id="$route.params.sorId"-->
    <!--                   :refresh-trigger.sync="refreshTrigger"-->
    <!--                   :sor-finalised="!!sor.finalised_at"></SectionList>-->
    <!--    </v-row>-->
  </v-container>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import {ACTION_TYPES} from "@/store/types";
import SectionList from "@/components/section/SectionList";
import ImportActionInputDialog from "@/components/sor/ImportActionInputDialog";
import VolumeList from "@/components/volume/VolumeList";
import CreateVolumeDialog from "@/components/volume/CreateVolumeDialog";
import {PERMISSIONS, SOR_TYPE} from "@/constants";

export default {
  name: 'SoR',
  components: {VolumeList, SectionList, SorList},
  setup(props, {root}) {
    const sor = ref(null);
    const getSor = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/',
        params: {sor_id: root.$route.params.sorId},
      });

      if (response.body.success) {
        if (response.body.sor.type === SOR_TYPE.CORRIGENDUM) {
          root.$router.replace({name: 'corrigendum-detail', params: {corrigendumId: response.body.sor.id}});
        }

        sor.value = response.body.sor;
      }
    }

    const actionItems = computed(() => {
      if (sor.value && sor.value.action_input) {
        return [sor.value.action_input];
      }

      return [];
    });
    const actionHeaders = ref([
      {text: root.$t('action_input.created_at'), value: 'created_at', width: 150},
      {text: root.$t('action_input.filename'), value: 'filename'},
      {text: root.$t('action_input.finalised_at'), value: 'finalised_at', width: 150},
    ])
    const importActionInput = async function () {
      await root.$dialog.showAndWait(ImportActionInputDialog, {
        sorId: root.$route.params.sorId,
        showClose: false,
        persistent: true,
      });
      await getSor();
    }
    const finaliseActionInput = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.finalise_action_input_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/sor/finalise_action_input/',
          params: {sor_id: root.$route.params.sorId},
        });

        if (response.body.success) {
          await getSor();
        }
      }
    }
    const unfinaliseActionInput = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.unfinalise_action_input_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/sor/unfinalise_action_input/',
          params: {sor_id: root.$route.params.sorId},
        });

        if (response.body.success) {
          await getSor();
        }
      }
    }

    const createVolume = async function () {
      const result = await root.$dialog.showAndWait(CreateVolumeDialog, {
        sorId: root.$route.params.sorId,
        showClose: false,
        persistent: true,
        width: 480,
      })

      if (result === true) {
        refresh()
      }
    }
    const finaliseSor = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.finalise_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/sor/finalise/',
          params: {sor_id: root.$route.params.sorId},
        });

        if (response.body.success) {
          await getSor();
        }
      }
    }
    const unfinaliseSor = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.un_finalise_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/sor/unfinalise/',
          params: {sor_id: root.$route.params.sorId},
        });

        if (response.body.success) {
          await getSor();
        }
      }
    }

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    onMounted(() => {
      getSor();
    })

    return {
      sor,
      getSor,

      actionItems,
      actionHeaders,
      importActionInput,
      finaliseActionInput,
      unfinaliseActionInput,

      createVolume,
      finaliseSor,
      unfinaliseSor,

      refreshTrigger,
      refresh,

      PERMISSIONS,
    }
  }
}
</script>

<style lang="less">
.sor-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sor-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .sor-info {
      flex: 1 1 0;
    }

    .sor-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .sor-action-input-disable-row {
    background-color: rgba(238, 119, 122, 0.1);
  }

  .sor-finalised-div {
    border: solid 1px #5BC23F;
    border-radius: 12px;
    color: #5BC23F;
    background-color: rgba(91, 194, 63, 0.2);
    padding: 2px 8px;
    margin-left: 8px;
  }

  .sor-action-input-row, .sor-detail-section-title {
    background-color: #FFFFFF;
  }
}
</style>
